// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-custom {
  background-color: rgba(32, 32, 32, 0.8) !important;
  /* border: 1px solid green !important; */
  border-radius: 15px 0px 15px !important;
}

.btn-custom span {
 color: rgba(255, 255, 255, 0.8);
}

.btn-custom:hover {
  background-color: rgba(0, 192, 0, 0.8) !important;
  border: 1px solid rgba(0, 192, 0, 0.8) !important;
}

.btn-custom:hover span {
 color: rgba(16, 16, 16, 0.8);
}

.round-btn {
  background-color: rgba(0, 98, 65, 0.98);
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.98);
  text-decoration: none;
  border: none;
  border-radius: 15px;
  padding: 5px 10px 5px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/verification.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;EACE,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":[".btn-custom {\n  background-color: rgba(32, 32, 32, 0.8) !important;\n  /* border: 1px solid green !important; */\n  border-radius: 15px 0px 15px !important;\n}\n\n.btn-custom span {\n color: rgba(255, 255, 255, 0.8);\n}\n\n.btn-custom:hover {\n  background-color: rgba(0, 192, 0, 0.8) !important;\n  border: 1px solid rgba(0, 192, 0, 0.8) !important;\n}\n\n.btn-custom:hover span {\n color: rgba(16, 16, 16, 0.8);\n}\n\n.round-btn {\n  background-color: rgba(0, 98, 65, 0.98);\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.98);\n  text-decoration: none;\n  border: none;\n  border-radius: 15px;\n  padding: 5px 10px 5px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
